import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, message, DatePicker } from 'antd';
import { patchUser } from '../apis/usersApi';
import Features from '../enums/features';
import dayjs from 'dayjs';
import { fetchUsersByRoleIdForBranch } from '../apis/rolesApi';
import Roles from '../enums/Roles';


const EditUserModal = ({ visible, onClose, user = null, initialFollowers = [], onUpdated }) => {
  const [form] = Form.useForm();
  const [isAdminUserEditionEnabled, setIsAdminUserEditionEnabled] = useState(false);
  const [followers, setFollowers] = useState(initialFollowers);

  const loadFollowers = async () => {
    try{
      const branch_id = localStorage.getItem('branch_id');
      const response = await fetchUsersByRoleIdForBranch(Roles.CLIENT_FOLLOWER, branch_id);
      setFollowers(response);
    } catch (error) {
      console.error('EditUserModal - loadFollowers, Error fetching client followers:', error);
      message.error("Error al cargar las madrinas. Contacta al soporte");
      setFollowers([]);
    }
  };

  useEffect(() => {
    if (isAdminUserEditionEnabled && !initialFollowers.length) {
      loadFollowers();
    }
  }, [initialFollowers.length, isAdminUserEditionEnabled]);

    useEffect(() => {
        function checkFeatures() {
            const features = JSON.parse(localStorage.getItem('user_features') || '{}');
            setIsAdminUserEditionEnabled(features[Features.ADMIN_USER_EDITION] || false);
        }
        checkFeatures();
    }, []);

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        name: user.name,
        surname_1: user.surname_1,
        surname_2: user.surname_2,
        phone: user.phone,
        email: user.email,
        assigned_id: user.assigned_id,
        birthdate: user.birthdate ?  
          dayjs(user.birthdate).utc().format('YYYY-MM-DD')
          && dayjs(dayjs(user.birthdate).utc().format('YYYY-MM-DD'), 'YYYY-MM-DD') : null,
      });
    } else {
      form.resetFields();
    }
  }, [user, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!user) return onClose();
      values.birthdate = values.birthdate ? values.birthdate.format('YYYY-MM-DD') : null;
      const res = await patchUser(user.id, values);
      if (res.success) {
        message.success('Usuario actualizado');
        onUpdated && onUpdated(res.data);
        onClose();
      } else {
        message.error('Error actualizando usuario');
      }
    } catch (err) {
      message.error('Por favor, corrija los errores en el formulario');
    }
  };

  return (
    <Modal
      title={`Editar usuario ${user ? `${user.name} ${user.surname_1}` : ''}`}
      open={visible}
      onCancel={onClose}
      onOk={handleOk}
      okText="Guardar"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Nombre" rules={[{ required: true, message: 'Ingrese nombre' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="surname_1" label="Apellido" rules={[{ required: true, message: 'Ingrese apellido' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="surname_2" label="2do Apellido">
          <Input />
        </Form.Item>
        <Form.Item name="phone" label="Celular">
          <Input />
        </Form.Item>
        <Form.Item name="email" label="Email" rules={[{ type: 'email', message: 'Email inválido' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="birthdate"
          label="Fecha de Nacimiento"
        >
          <DatePicker
            placeholder="Fecha de Nacimiento"
            format="DD/MM/YYYY"
            disabledDate={(current) =>
              current && current > dayjs().endOf('day') /* Do not use moment and maxDate it causes a bug changing the date*/
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            className="d-block m-auto"
          />
        </Form.Item>

        { isAdminUserEditionEnabled &&
          <Form.Item name="assigned_id" label="Madrina">
            <Select allowClear options={followers.map((f) => ({ value: f.id, label: f.name }))} />
          </Form.Item>
        }
      </Form>
    </Modal>
  );
};

export default EditUserModal;
